<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" title="RII大货建单" width="1200">
        <el-form :inline="false"  class="" style="text-align: left">
          <div class="flex flex-row-left flex-item-start">
            <div style="flex:2">
              <el-form-item  label="RII出库单号">
                <el-input style="width:200px" disabled v-model="formInline.riiNumber" placeholder="创建自动生成" ></el-input>
              </el-form-item>
              <el-form-item  label="发货仓库">
                <el-select
                    :disabled="disable"
                    v-model="formInline.warehouseCode"
                    filterable
                    allow-create
                    default-first-option
                    @change="getSelect"
                    :reserve-keyword="false"
                    placeholder="请选择仓库"
                    style="width: 200px"
                >
                  <el-option
                      v-for="item in defaultOption"
                      :key="item.StoreNum"
                      :label="item.StoreName"
                      :value="item.StoreNum"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="原订单参考号">
                <el-input style="width:200px" disabled v-model="formInline.salesRecordNumber" ></el-input>
              </el-form-item>
              <el-form-item label="收货人">
                <el-input style="width:200px" disabled v-model="formInline.userInfo.name " ></el-input>
              </el-form-item>
              <el-form-item label="收货人电话">
                <el-input style="width:200px" disabled v-model="formInline.userInfo.phone" ></el-input>
              </el-form-item>
              <el-form-item label="收货人地址">
                <el-input  disabled style="min-width: 240px"
                           :autosize="{ minRows: 2, maxRows: 8}"
                           type="textarea" v-model="formInline.addressStr"></el-input>
              </el-form-item>
              <el-form-item label="发货备注">
                <el-input style="width:200px"  v-model="formInline.userRemark"></el-input>
              </el-form-item>
            </div>
            <div style="flex:3">
              <el-form-item label="发货类型">
                <el-radio-group disabled v-model="formInline.stockType" size="small">
                  <el-radio-button label="FBA仓库" value="TO_FBA_WAREHOUSE" />
                  <el-radio-button label="海外地址" value="TO_THIRD_ADDRESS" />
                </el-radio-group>
              </el-form-item>
              <el-form-item label="派送方式">
                <el-radio-group v-model="formInline.shippingMode" size="small">
                  <el-radio-button label="卡车派送" value="TRUCK" />
                  <el-radio-button label="快递派送" value="COURIER" />
                </el-radio-group>
              </el-form-item>
              <el-form-item label="自定义时段发货">
                <el-radio-group v-model="formInline.isCustomerDeliver" size="small">
                  <el-radio-button label="是" value="1" />
                  <el-radio-button label="否" value="0" />
                </el-radio-group>
              </el-form-item>
              <el-form-item label="装箱服务">
                <el-radio-group disabled v-model="formInline.packingService" size="small">
                  <el-radio-button label="使用原箱" value="ORIGINAL_BOX" />
                  <el-radio-button label="重新装箱" value="REPACKING" />
                </el-radio-group>
              </el-form-item>
              <el-form-item label="增值服务">
                <el-radio-group disabled v-model="formInline.valueAddedServiceCode" size="small">
                  <el-radio-button label="正常" value="NORMAL" />
                  <el-radio-button label="暂停" value="SUSPEND" />
                  <el-radio-button label="加急" value="URGENT" />
                </el-radio-group>
              </el-form-item>
              <el-form-item label="产品换标服务">
                <el-radio-group disabled v-model="formInline.productLabelCode" size="small">
                  <el-radio-button label="不需要" value="NO_CHANGE" />
                  <el-radio-button label="按商品上传换帖标签" value="GOODS_LABEL" />
                  <el-radio-button label="统一上传全部商品换标签" value="CHANGE_SKU" />
                </el-radio-group>
              </el-form-item>
              <el-form-item label="外箱贴标服务">
                <el-radio-group disabled v-model="formInline.packingLableCode" size="small">
                  <el-radio-button label="不需要" value="NO_STICK" />
                  <el-radio-button label="配货后上传" value="DISTRIBUTE_UPLOAD" />
                  <el-radio-button label="上传外箱贴" value="NEED_LABEL" />
                </el-radio-group>
              </el-form-item>
              <el-form-item label="托盘贴标服务">
                <el-radio-group disabled v-model="formInline.palletLabelCode" size="small">
                  <el-radio-button label="不需要" value="NO_STICK" />
                  <el-radio-button label="配货后上传" value="DISTRIBUTE_UPLOAD" />
                  <el-radio-button label="上传托盘标签" value="NEED_LABEL" />
                </el-radio-group>
              </el-form-item>
              <el-form-item label="下推 RII 平台">
                <el-radio-group v-model="formInline.sendChannel" size="small">
                  <el-radio-button label="DTC" value="shopify" />
                  <el-radio-button label="VC" value="shopifyvc" />
                  <el-radio-button label="online" value="shopifyonline" />
                  <el-radio-button label="offline" value="shopifyoffline" />
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <div style="width: 80%;margin: 0 auto;">
            <el-checkbox label="整单" v-model="isAll" />
            <el-table :data="formInline.boxUpcStockList" class="sku-table" stripe>
              <el-table-column prop="sku" label="SKU" width="150">
                <template #default="scope">
                  <el-input v-model="scope.row.sku" placeholder="请输入SKU"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="quantity" label="发货数量" width="150">
                <template #default="scope">
                  <el-input-number v-model="scope.row.quantity" :min="1" :max="1000" controls-position="right"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="singleBoxQuantity" label="原箱单件数量" width="150">
                <template #default="scope">
                  <el-input-number v-model="scope.row.singleBoxQuantity" :min="1" :max="1000" controls-position="right"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="barcode" label="是否更换条形码" width="180">
                <template #default="scope">
                  <el-radio-group v-model="scope.row.changeLabelType" size="small">
                    <el-radio-button label="不换" value="NO_CHANGE" />
                    <el-radio-button label="更换" value="CHANGE_SKU" />
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column prop="barcode" label="更换条形码编号" width="180">
                <template #default="scope">
                  <el-input v-model="scope.row.changeBarcode" placeholder="请输入条形码"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="barcode" label="换标新条形码" width="180">
                <template #default="scope">
                  <el-upload
                      ref="upload"
                      v-model:file-list="scope.row.newLabel"
                      class="upload-demo"
                      :action="uploadUrl"
                      :limit="1"
                      :on-exceed="handleExceed"
                      :on-success="handleNewLabel"
                      :before-upload="handleBeforeUpload"
                      accept=".pdf"
                      :on-preview= "handlePreview"
                  >
                    <el-button type="primary">选择上传文件</el-button>
                    <template #tip>
                      <div class="el-upload__tip">
                        只允许上传pdf文件
                      </div>
                    </template>
                  </el-upload>
                </template>
              </el-table-column>
              <el-table-column prop="barcode" label="装箱贴文件" width="180">
                <template #default="scope">
                  <el-upload
                      ref="cartonFile1"
                      v-model:file-list="scope.row.cartonFile1"
                      class="upload-demo"
                      :action="uploadUrl"
                      :limit="1"
                      :on-exceed="handleCartonFile1Exceed"
                      :on-success="handleCartonFile1"
                      :before-upload="handleBeforeUpload"
                      accept=".pdf"
                      :on-preview= "handlePreview"
                  >
                    <el-button type="primary">选择上传文件</el-button>
                    <template #tip>
                      <div class="el-upload__tip">
                        只允许上传pdf文件
                      </div>
                    </template>
                  </el-upload>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template #default="scope">
                  <el-button size="small" type="danger" @click="removeSku(scope.$index)" icon="el-icon-delete" circle>移除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-form-item  v-if="formInline.sendChannel && formInline.sendChannel.startsWith('shopify')" label="RII自动预约卡派">
            <el-checkbox label="自动预约" v-model="formInline.isAotuSend" />
          </el-form-item>
          <div class="flex flex-row-right flex-item-center">
            <el-button style="margin: 0 auto" type="primary" @click="submit" >保存</el-button>
          </div>

        </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElInputNumber,
  ElRadioGroup,
  ElRadioButton,
  ElButton,
  ElSelect,
  ElOption, genFileId, ElMessage,ElCheckbox,
  ElTable,ElTableColumn,ElUpload
} from "element-plus";
import {getStoreList,addRIIBigStock,getRIIModifyFile} from "@/utils/api";
import {getNextWeekDay} from "../../public/js/index"
import {uploadUrl} from "@/utils/requset"
export default {
  name: "addRIIForm",
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElInput,
    ElInputNumber,
    ElRadioGroup,
    ElRadioButton,
    ElButton,
    ElSelect,
    ElOption,
    ElCheckbox,
    ElTable,ElTableColumn,ElUpload
  },
  data(){
    return{
      dialogTableVisible:false,
      uploadUrl:"",
      materialNo:"",
      isAll:true,
      formInline:{
        warehouseCode:"US-SACO",
        sendChannel:"bby",
        isAotuSend:false,
        userInfo:{},
        stockType:"TO_THIRD_ADDRESS",
        shippingMode:"TRUCK",
        isCustomerDeliver:"1",
        referenceBoxes:"1",
        packingService:"ORIGINAL_BOX",
        valueAddedServiceCode:"NORMAL",
        productLabelCode:"GOODS_LABEL",
        packingLableCode:"NEED_LABEL",
        palletLabelCode:"NO_STICK",
        boxUpcStockList:[
          {
            newLabel:[],
            cartonFile1:[],
            Quantity:1,
            singleBoxQuantity:1,
            changeBarcode:"",
          }
        ],
        userRemark:""
      },
      disable:false,
      defaultOption:[]
    }
  },
  beforeMount() {
    this.uploadUrl =uploadUrl
    this.getStoreList()
  },
  methods:{
    getStoreList(){
      getStoreList().then(res=>{
        console.log(res)
        this.defaultOption = res.Data || []
        // 追加 RII 2B 仓库选项（RII-CA2 已在接口返回中）
        this.defaultOption.push(
          { StoreNum: 'RII-2B', StoreName: 'RII 2B' }
        )
      }).catch(err=>{
        console.log(err)
      })
    },
    getRIIModifyFile(){
      // 先清空现有数据，避免缓存旧数据
      this.formInline.boxUpcStockList = [
        {
          newLabel:[],
          cartonFile1:[],
          Quantity:1,
          singleBoxQuantity:1,
          changeBarcode:"",
        }
      ]
      
      getRIIModifyFile({salesRecordNumber:this.formInline.salesRecordNumber,platformOrder:this.formInline.platformOrder}).then(res=>{
        this.formInline.boxUpcStockList = res.Data || [
          {
            newLabel:[],
            cartonFile1:[],
            Quantity:1,
            singleBoxQuantity:1,
            changeBarcode:"",
          }
        ]
      }).catch(err=>{
        console.log(err)
        ElMessage.error('获取SKU数据失败，请检查网络连接，关闭弹窗重新下推数据')
        // 确保失败时数据已被重置为空数组或默认结构
      })
    },
    open(data,channel='bby'){
      this.dialogTableVisible = true
      // 每次打开弹窗，重置仓库为默认值 RII-CA2
      this.formInline.warehouseCode = 'US-SACO'
      this.formInline.materialNo= data.materNum
      this.formInline.platformOrder = data.platformOrder
      this.formInline.salesRecordNumber = data.salesRecordNumber
      this.formInline.shippingMode = 'TRUCK'
      if(data.salesRecordNumber && data.salesRecordNumber.startsWith('BBY03')){
        this.formInline.sendChannel = 'shopifyonline'
      } else if(channel === 'bby'){
        this.formInline.sendChannel = 'shopifyoffline'
      } else {
        this.formInline.sendChannel = channel
      }
      this.formInline.userInfo = data.userInfo
      this.formInline.address = data.address
      // 根据不同渠道设置默认值
      if(data.salesRecordNumber && data.salesRecordNumber.startsWith('BBY03')){
        this.formInline.userRemark = "75 寸定制卡板"
        this.formInline.isCustomerDeliver = "0"
      } else if(channel === 'shopify'){
        this.formInline.userRemark = "75 寸定制托盘"
        this.formInline.productLabelCode = "NO_CHANGE"
        this.formInline.isCustomerDeliver = "0"
        this.formInline.changeBarcode = ""
        this.formInline.newLabel = []
        this.formInline.packingLableCode = "NO_STICK"
        this.formInline.palletLabelCode = "shopify"
        this.formInline.sendChannel = "shopify"
      } else {
        this.formInline.userRemark = getNextWeekDay()+"提货，卡派"
      }
      this.formInline.addressStr= data.address.country +'\n'+data.address.province+'\n'+data.address.city+'\n'+data.address.district+'\n'+data.address.street1
      this.getRIIModifyFile()
    },
    getSelect(value){
      console.log(value)
    },
    submit(){
      if(!this.formInline.warehouseCode){
        ElMessage.warning('请选择RII出货仓库')
        return
      }
      
      // 检查SKU是否为空
      if(!this.formInline.boxUpcStockList || this.formInline.boxUpcStockList.length === 0){
        ElMessage.warning('请至少添加一个SKU')
        return
      }
      
      // 检查每个SKU是否填写
      for(let i = 0; i < this.formInline.boxUpcStockList.length; i++){
        const item = this.formInline.boxUpcStockList[i]
        if(!item.sku || item.sku.trim() === ''){
          ElMessage.warning(`第${i+1}行SKU不能为空，请填写SKU`)
          return
        }
      }
      
      addRIIBigStock(this.formInline).then(res=>{
        this.dialogTableVisible = false
        this.$emit('close',res)
      }).catch(err=>{
        console.log(err)
      })
    },
    handleNewLabel(response){
      console.log(response)
      console.log(this.formInline.salesRecordNumber)
      //this.formInline.newLabel = [{name:response.filename,url:response.location}]
    },
    handleCartonFile1(response){
      console.log(response)
      console.log(this.formInline.salesRecordNumber)
      //this.formInline.cartonFile1 = [{name:response.filename,url:response.location}]
    },
    handleExceed(files){
      this.$refs.upload.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      this.$refs.upload.handleStart(file);
    },
    handleCartonFile1Exceed(files){
      this.$refs.cartonFile1.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      this.$refs.cartonFile1.handleStart(file);
    },
    removeSku(index){
      this.formInline.boxUpcStockList.splice(index, 1);
    },
    handleBeforeUpload(file){
      const fileExt = file.name.split('.').pop().toLowerCase();
      // 方法2：检查MIME类型（更可靠）
      const isPDF = file.type === 'application/pdf';

      if (fileExt !== 'pdf' || !isPDF) {
        ElMessage.error('只能上传PDF格式文件');
        return false;
      }
      return true;
    },
    handlePreview(file) {
      try {
        if (file.raw.type === "application/pdf") {
          const blob = new Blob([file.raw], {type: 'application/pdf'})
          window.open(URL.createObjectURL(blob), "_blank")
        }
      }catch (e) {
        const fileExt = file.name.split('.').pop().toLowerCase();
        if (fileExt=="pdf") {
          window.open(file.url, "_blank")
        }
      }
    }
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 200px;
}
.container {
  max-width: 1200px;
  margin: 20px auto;
  padding: 20px;
  font-family: 'Helvetica Neue', Arial, sans-serif;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}
.sku-section {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.section-title i {
  margin-right: 8px;
  color: #409EFF;
}
.sku-table {
  width: 100%;
  margin-bottom: 20px;
}
.sku-table th {
  background-color: #f5f7fa;
  padding: 12px 15px;
  text-align: left;
  font-weight: 600;
  color: #606266;
}
.sku-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #ebeef5;
}
.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
.upload-area {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
}
.upload-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.upload-label {
  min-width: 180px;
  font-weight: 500;
  color: #606266;
}
.summary-card {
  background-color: #ecf5ff;
  border-left: 4px solid #409EFF;
  padding: 15px;
  border-radius: 4px;
  margin-top: 20px;
}
.summary-item {
  display: flex;
  margin-bottom: 8px;
}
.summary-label {
  min-width: 160px;
  font-weight: 500;
  color: #606266;
}
.summary-value {
  font-weight: 600;
  color: #303133;
}
.el-tag {
  margin-right: 5px;
}
</style>